import './player.scss';
import React, { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';
import videojsqualityselector from 'videojs-hls-quality-selector';
import { isPlatformBrowser, setTitle } from '../../shared/services/general/general-service';
import { Link, useHistory } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Icon, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import { sendAnalyticsEvent } from '../../shared/services/analytics/analytics-service';
import { useConfigApp } from '../../shared/services/general/app-context';
import { Helmet } from 'react-helmet';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

require('videojs-contrib-ads');
require('videojs-ima');
require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector');
require('videojs-seek-buttons');

const getSeriesInfoFromLocalStorage = () => {
	try {
		const stored = JSON.parse(localStorage.getItem('selectedEpisodeInfo'));
		if (!stored) {
			console.log('❌ No data in localStorage');
			return null;
		}

		if (!stored.seasons) {
			console.log('❌ No seasons data in localStorage');
			return null;
		}

		const seasons = [];
		for (let key in stored.seasons) {
			const episodes = stored.seasons[key];
			if (Array.isArray(episodes)) {
				seasons.push({
					title: `فصل ${parseInt(key).toLocaleString('fa')}`,
					seasonNumber: parseInt(key),
					episodes: episodes
				});
			}
		}

		return {
			seasons,
			title: stored?.title,
			programId: stored?.programId,
			selected: stored.selected || null
		};
	} catch (e) {
		console.error("❌ Error parsing localStorage:", e);
		return null;
	}
};

export default function PlayerComponent({ data, id }) {
	const videoRef = useRef();
	const [player, setPlayer] = useState(null);
	const [playLink, setPlayLink] = useState(null);
	const [showSkipTitration, setShowSkipTitration] = useState(false);
	const [closeSubAlert, setCloseSubAlert] = useState(false);
	const configApp = useConfigApp();
	const history = useHistory();
	const [showEpisodeList, setShowEpisodeList] = useState(false);
	const [expanded, setExpanded] = useState('panel1');
	const [seasonsFromStorage, setSeasonsFromStorage] = useState([]);
	const [selectedEpisode, setSelectedEpisode] = useState(null);

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	// تابع به‌روزرسانی localStorage
	const updateSelectedEpisodeInStorage = (episodeData) => {
		try {
			const stored = JSON.parse(localStorage.getItem('selectedEpisodeInfo'));
			if (stored) {
				stored.selected = episodeData;
				localStorage.setItem('selectedEpisodeInfo', JSON.stringify(stored));
				setSelectedEpisode(episodeData);
				console.log("✅ Updated selected episode in localStorage:", episodeData);
			}
		} catch (e) {
			console.error("❌ Error updating localStorage:", e);
		}
	};

	useEffect(() => {
		const seriesInfo = getSeriesInfoFromLocalStorage();
		setTitle('پخش برنامه‌ی ' + data?.title || seriesInfo?.title);

		const hideOtherElement = () => {
			if (isPlatformBrowser()) {
				let main_section = document.getElementsByClassName('main-section');
				let header = document.getElementById('header');
				let navigator = document.getElementById('navigator');
				if (main_section && main_section.length) main_section.item(0).style.margin = 0;
				if (header) header.style.display = 'none';
				if (navigator) navigator.style.display = 'none';
			}
		};

		hideOtherElement();
		initialPlayer();
		setPlayLink(data?.link);

		if (seriesInfo && seriesInfo.seasons && seriesInfo.seasons.length > 0) {
			setSeasonsFromStorage(seriesInfo.seasons);
			setSelectedEpisode(seriesInfo.selected);

			if (seriesInfo.selected?.season) {
				setExpanded(`panel${seriesInfo.selected.season}`);
			}
			// console.log('✅ Episode list should be visible now');
		} else {
			console.log('❌ No valid series info found');
		}
	}, [id, data]);

	useEffect(() => {
		if (player && data?.link) {
			let newPlayLink = data.link;

			if (configApp?.media_id) {
				newPlayLink = data.link.replace(/mediaId=[^&]*/, `mediaId=${configApp.media_id}`);
			}

			setPlayLink(newPlayLink);

			player.src({
				src: newPlayLink,
				autoplay: true,
			});

			const seriesInfo = getSeriesInfoFromLocalStorage();
			if (seriesInfo) {
				setSeasonsFromStorage(seriesInfo.seasons);
				setSelectedEpisode(seriesInfo.selected);
				setExpanded(`panel${seriesInfo.selected.season}`);
				// setShowEpisodeList(true);
			}

			// console.log("🎬 Video source updated for episode:", id);
		}
	}, [id, data, configApp?.media_id, player]);

	useEffect(() => {
		return () => {
			if (player) {
				player.dispose();
			}

			const showOtherElements = () => {
				if (isPlatformBrowser()) {
					let main_section = document.getElementsByClassName('main-section');
					let header = document.getElementById('header');
					let navigator = document.getElementById('navigator');
					if (main_section && main_section.length && window.innerWidth > 980)
						main_section.item(0).style.marginTop = '70px';
					if (header && window.innerWidth > 980) header.style.display = 'flex';
					if (navigator && window.innerWidth <= 980) navigator.style.display = 'flex';
				}
			};
			showOtherElements();
		};
	}, [player]);

	useEffect(() => {
		const toggle = () => setShowEpisodeList(prev => !prev);
		window.addEventListener("toggleEpisodeList", toggle);

		return () => {
			window.removeEventListener("toggleEpisodeList", toggle);
		};
	}, []);

	useEffect(() => {
		if (player) {
			const seriesInfo = getSeriesInfoFromLocalStorage();
			if (playLink !== "" && configApp?.media_id) {
				setPlayLink(playLink.replace(/mediaId=[^&]*/, `mediaId=${configApp.media_id}`));
			}
			player.src({
				src: playLink,
				autoplay: true,
			});
			player.seekButtons({ forward: 30, back: 10 });
			player.hlsQualitySelector = videojsqualityselector;
			player.hlsQualitySelector();
			customPlayerControlBar();
			sendAnalyticsEvent('watch', {
				id: id,
				title: data?.title || seriesInfo?.title
			});

			player.ima({
				autoplay: true,
				adTagUrl: "https://api.mediaad.org/v1/bebin.com/vast/114112"
			});

			player.ready(() => {
				player?.posterImage?.hide();
				player.on('loadedmetadata', () => {
					const posterElement = document.querySelector('.vjs-poster');
					if (posterElement) posterElement.parentNode.removeChild(posterElement);
				});
				player.on('adsready', () => {
					player.ima.initializeAdDisplayContainer();
					player.play();
				});
				player.on('adserror', (e) => {
					console.error("Ad Error:", e);
				});
			});
		}
	}, [player]);

	useEffect(() => {
		if (player?.currentTime()) {
			setInterval(() => {
				setShowSkipTitration(player?.currentTime() > 10 && player?.currentTime() < 70);
			}, 1000);
		}
	}, [player]);

	const onHandleSubAlert = () => {
		setCloseSubAlert(true);
	};

	const renderSubscriptionAlert = () => {
		return (
			!closeSubAlert && (
				<div className="sub-alert">
					<Icon component={CloseIcon} onClick={onHandleSubAlert} />
					<p>تعرفه ترافیک مصرفی شما به صورت <strong> تمام بها</strong> محاسبه میشود</p>
				</div>
			)
		);
	};

	function initialPlayer() {
		const options = {
			aspectRatio: '16:9',
			controls: true,
			preload: 'auto',
			fluid: false,
			autoplay: 'play',
			poster: '',
			displayCurrentQuality: true,
			playbackRates: [.25, .5, 1, 1.5, 2],
			html5: {
				hls: {
					overrideNative: true
				}
			},
			hls: {
				withCredentials: true
			}
		};
		setPlayer(videojs(videoRef.current, options));
		videojs(videoRef.current).addClass('no-poster');
	}

	const addCustomIconButton = () => {
		const Button = videojs.getComponent('Button');

		if (!videojs.getComponent('CustomButton')) {
			class CustomButton extends Button {
				constructor(player, options) {
					super(player, options);
					this.controlText("لیست فصل‌ها");
					this.addClass('vjs-custom-button');

					const iconContainer = document.createElement("span");
					iconContainer.className = "vjs-custom-button-icon";
					iconContainer.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="white">
						<path d="M3 10h11v2H3v-2zm0-4h11v2H3V6zm0 8h7v2H3v-2zm13 0v4l4-2-4-2z"/>
					</svg>
				`;
					this.el().appendChild(iconContainer);

					const tooltipKey = 'hasSeenEpisodeTooltip';

					if (!localStorage.getItem(tooltipKey)) {
						const tooltip = document.createElement('div');
						tooltip.className = 'tooltip-once';
						tooltip.innerHTML = `
							<span class="tooltip-text">برای دیدن لیست قسمت‌ها کلیک کن!</span>
							<span class="tooltip-arrow"></span>
						`;

						iconContainer.style.position = 'relative';
						iconContainer.appendChild(tooltip);

						player.one('play', () => {
							setTimeout(() => {
								tooltip.classList.remove('show');
								setTimeout(() => tooltip.remove(), 300);
								localStorage.setItem(tooltipKey, 'true');
							}, 10000);
						});

						tooltip.classList.add('show');
					}

				}

				handleClick() {
					window.dispatchEvent(new Event("toggleEpisodeList")); // کامپوننت بیرونی رو از طریق event مطلع می‌کنیم
				}
			}

			videojs.registerComponent('CustomButton', CustomButton);
		}

		// اضافه‌کردن بدون تأخیر
		if (player && player.controlBar) {
			player.controlBar.addChild('CustomButton', {}, player.controlBar.children_.length - 1);
		}
	};

	const customPlayerControlBar = () => {
		const seriesInfo = getSeriesInfoFromLocalStorage();
		const renderVideoName = () => {
			const returnBtn = document.createElement('BUTTON');
			returnBtn.setAttribute('class', 'return-btn');
			returnBtn.addEventListener('click', () => {
				if (!seriesInfo) {
					history.goBack();
				} else {
					localStorage.removeItem('selectedEpisodeInfo')
					history.push(`/series/${seriesInfo?.programId}`);
				}

			});

			document?.getElementsByClassName('vjs-custom-control-spacer')?.item(0)?.appendChild(returnBtn);
			document?.getElementsByClassName('vjs-custom-control-spacer')?.item(0)?.append(data?.title || seriesInfo?.title);
		};

		const renderOperations = () => {
			const otherOperations = document?.createElement('DIV');
			otherOperations.setAttribute('class', 'other-operations');
			const settingBtnMenu = document?.getElementsByClassName('vjs-quality-selector')?.item(0)
				?.getElementsByClassName('vjs-menu')?.item(0);
			settingBtnMenu?.appendChild(otherOperations);
		};

		if (document && player) {
			renderVideoName();
			if (seriesInfo) {
				addCustomIconButton();
			}
			setTimeout(() => {
				renderOperations();
			}, 5000);
		}
	};

	return (
		<div className="main-container">
			<Helmet>
				<meta name="robots" content="noindex, follow" />
				<link rel="canonical" href={`https://bebin.com/player/${id}`} />
			</Helmet>
			{renderSubscriptionAlert()}

			<video
				className="video-js"
				ref={videoRef}
				id="video"
				crossOrigin="anonymous"
				controls
				autoPlay
				playsInline
				preload="auto"
				width="640"
				height="264"
			>
				<source src="//vjs.zencdn.net/v/oceans.mp4" type="video/mp4" />
			</video>

			{showEpisodeList && (
				<div className="episode-panel">
					<div className="episode-panel__header">
						<span>فهرست پخش</span>
						<Icon component={CloseIcon} onClick={() => setShowEpisodeList(false)} />
					</div>

					<div className="episode-panel__body">
						{seasonsFromStorage.length === 0 && (
							<div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
								<p>هیچ فصلی یافت نشد</p>
							</div>
						)}

						{seasonsFromStorage.map((season, index) => (
							<Accordion
								key={index}
								className="accordion"
								square
								expanded={expanded === `panel${index + 1}`}
								onChange={handleChange(`panel${index + 1}`)}
							>
								<AccordionSummary
									className="accordion__summary"
									expandIcon={<ExpandMoreIcon style={{ color: '#ccc' }} />}
									aria-controls={`panel${index + 1}d-content`}
									id={`panel${index + 1}d-header`}
								>
									<Typography>{season.title}</Typography>
								</AccordionSummary>
								<AccordionDetails className="accordion__details">
									{season?.episodes.map((ep, i) => (
										<div key={i} className={`episode${selectedEpisode?.videoId === ep.videoId ? ' episode-selected' : ''}`}>
											<Link
												to={`/player/${ep.videoId}`}
												onClick={() => {
														updateSelectedEpisodeInStorage({
															videoId: ep.videoId,
															episodeNumber: ep.episodeNumber,
															season: season.seasonNumber,
															title: ep.title || `قسمت ${ep.episodeNumber}`,
															programId: data?.id,
														});
													}
												}
												className={selectedEpisode?.videoId === ep.videoId ? 'active-episode' : ''}
											>
												{selectedEpisode?.videoId === ep.videoId && (
													<Icon component={PlayArrowIcon} />
												)}
												قسمت {ep?.episodeNumber}
											</Link>
										</div>
									))}
								</AccordionDetails>
							</Accordion>
						))}
					</div>
				</div>
			)}
		</div>
	);
}